export const selectCookie = (cookie) => ({
	name: cookie.name,
	categoryId: cookie.categoryId,
	active: true,
	category: {
		name: cookie.category.name,
		label: cookie.category.label,
		description: cookie.category.description,
	},
});

export const selectCookies = (cookies) =>
	cookies.map((cookie) => selectCookie(cookie));
